
<div class="row m-0 p-0" style="height:  calc(100vh - 168px)">

  <div class="panel-info" [class.active]="info">

    <div *ngIf="!loadingInfo" class="d-flex flex-column justify-content-between  h-100">
      <div>
        <div class="card mb-0" style="border-radius: 0px !important; z-index: 10;">
          <div class="d-flex">
            <div class="col-5 p-3 m-0 d-flex justify-content-center align-items-center">
              <img *ngIf="serial.includes('EVVC3')" height="115px" src="../../../assets/img/orbis/uni_rec.png">
              <img *ngIf="serial.includes('EVVC4')" height="115px" src="../../../assets/img/orbis/combi+_rec.png">
              <img *ngIf="serial.includes('EVVC5')" height="125px" src="../../../assets/img/orbis/city+2.png">
              <img *ngIf="serial.includes('EVVC6')" height="100px" src="../../../assets/img/orbis/exo_rec.png">
              <img *ngIf="serial.includes('CTM')" height="100px" src="../../../assets/img/orbis/exo_rec.png">
              <img *ngIf="serial.includes('XLUM')" height="100px" src="../../../assets/img/orbis/xeolum+_rec.png">
              <img *ngIf="isRelaySchedulerSerial(serial)" height="100px" [src]="getRelayDeviceImage(serial, devices[indice]?.sub_type)">
              <img *ngIf="serial.includes('ANC2')" height="100px" src="../../../assets/img/orbis/astroMCB_rec.png">

            </div>
            <div class="col-7 p-2 py-3 d-flex row">
              <div>
                <div class="d-flex  justify-content-between align-items-center">
                  <h3 class="p-0 m-0"> {{devices[indice]?.name?  (devices[indice]?.name | uppercase ) : serial}}</h3>
                  <i class="fas fa-arrow-right  pe-1" style="cursor: pointer;" (click)="closeInfoPanel()"></i>
                </div>
                <h5 class="m-0"> {{serial}} </h5>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="badge bg-light text-dark fw-bold" style="font-size: 14px !important; border-radius: 30px !important;">v - {{devices[indice]?.firmware_version_name }} </span>
                <span class="badge badge-success" *ngIf="devices[indice]?.alive == 1 "> {{"connected" | translate}}</span>
                <span class="badge badge-danger" *ngIf="devices[indice]?.alive == 0 "> {{"disconnected" | translate}}</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="serial.includes('EVVC')" >

          <div class="row">
            <div class="col-6">
              <!-- Inst. Power -->
              <div class="card pt-2 pb-2 ms-3 sombreado mt-4">
                <div class="card-body text-center p-3">
                  <div class="row  ">
                    <div class="col-5 ">
                      <div class="avatar ">
                        <div class="avatar-title rounded-circle bg-primary ">
                          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                            <path fill="currentColor"
                              d="M8.28,5.45L6.5,4.55L7.76,2H16.23L17.5,4.55L15.72,5.44L15,4H9L8.28,5.45M18.62,8H14.09L13.3,5H10.7L9.91,8H5.38L4.1,10.55L5.89,11.44L6.62,10H17.38L18.1,11.45L19.89,10.56L18.62,8M17.77,22H15.7L15.46,21.1L12,15.9L8.53,21.1L8.3,22H6.23L9.12,11H11.19L10.83,12.35L12,14.1L13.16,12.35L12.81,11H14.88L17.77,22M11.4,15L10.5,13.65L9.32,18.13L11.4,15M14.68,18.12L13.5,13.64L12.6,15L14.68,18.12Z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-7 text-center" style="display: flex; justify-content: center; align-items: center;"> -->
                    <div class="col-7 p-0 m-0  d-flex justify-content-center align-items-center ">
                      <h4 class="p-0 m-0"> {{totalPower}} <span>w</span></h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <!-- Inst. Home -->
              <div class="card pt-2 pb-2 me-3 sombreado mt-4">
                <div class="card-body text-center p-3">
                  <div class="row  ">
                    <div class="col-5 ">
                      <div class="avatar ">
                        <div class="avatar-title rounded-circle bg-primary-light">
                          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="col-7 p-0 m-0  d-flex justify-content-center align-items-center ">
                      <h4 class="p-0 m-0 ">{{homePower}} <span>w</span></h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <!-- Inst. EV -->
              <div class="card pt-2 pb-2 ms-3 sombreado">
                <div class="card-body text-center p-3">
                  <div class="row  ">
                    <div class="col-5 ">
                      <div class="avatar ">
                        <div class="avatar-title rounded-circle  bg-blue-accent ">
                          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                            <path fill="currentColor"
                              d="M16,6L19,10H21C22.11,10 23,10.89 23,12V15H21A3,3 0 0,1 18,18A3,3 0 0,1 15,15H9A3,3 0 0,1 6,18A3,3 0 0,1 3,15H1V12C1,10.89 1.89,10 3,10L6,6H16M10.5,7.5H6.75L4.86,10H10.5V7.5M12,7.5V10H17.14L15.25,7.5H12M6,13.5A1.5,1.5 0 0,0 4.5,15A1.5,1.5 0 0,0 6,16.5A1.5,1.5 0 0,0 7.5,15A1.5,1.5 0 0,0 6,13.5M18,13.5A1.5,1.5 0 0,0 16.5,15A1.5,1.5 0 0,0 18,16.5A1.5,1.5 0 0,0 19.5,15A1.5,1.5 0 0,0 18,13.5Z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="col-7 p-0 m-0  d-flex justify-content-center align-items-center ">
                      <h4 class="p-0 m-0  ">{{evsePower}} <span>w</span></h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <!-- Inst. Solar -->
              <div class="card pt-2 pb-2 me-3 sombreado" *ngIf="solarInfo?.cfg?.enabled">
                <div class="card-body text-center p-3">
                  <div class="row  ">
                    <div class="col-5 ">
                      <div class="avatar ">
                        <div class="avatar-title rounded-circle bg-yellow text-primary">
                          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                            <path fill="currentColor"
                              d="M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M3.36,17L5.12,13.23C5.26,14 5.53,14.78 5.95,15.5C6.37,16.24 6.91,16.86 7.5,17.37L3.36,17M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M20.64,17L16.5,17.36C17.09,16.85 17.62,16.22 18.04,15.5C18.46,14.77 18.73,14 18.87,13.21L20.64,17M12,22L9.59,18.56C10.33,18.83 11.14,19 12,19C12.82,19 13.63,18.83 14.37,18.56L12,22Z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="col-7 p-0 m-0  d-flex justify-content-center align-items-center ">
                      <h4 class="p-0 m-0  ">{{fvPower}} <span>w</span></h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <!-- Battery Power -->
              <div class="card pt-2 pb-2 ms-3 sombreado mb-3" *ngIf="solarInfo?.cfg?.battery">
                <div class="card-body text-center p-3">
                  <div class="row  ">
                    <div class="col-5 d-flex  align-items-center ">
                      <div class="avatar " *ngIf="batteryCharging">
                        <div class="avatar-title rounded-circle ng-tns-c200-0 bg-green text-primary ">
                          <svg style="width:24px;height:24px" viewBox="0 0 512 512">
                            <path fill="currentColor"
                              d="M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z" />
                          </svg>
                        </div>
                      </div>
                      <div class="avatar " *ngIf="!batteryCharging">
                        <div class="avatar-title rounded-circle ng-tns-c200-0 bg-orange text-primary ">
                          <svg style="width:24px;height:24px" viewBox="0 0 512 512">
                            <path fill="currentColor"
                              d="M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="col-7 text-center">
                      <h4 class="p-0 m-0 ">{{battEnergy}} <span>w</span></h4>
                      <h4 class="p-0 m-0">{{battPercent}} <span>%</span></h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6"></div>
          </div>
          <div class="row">
            <!-- Swhitch -->
            <div class="col-12" *ngFor="let conn of connectors; index as i">
              <div class="card  ms-3 me-3 sombreado">
                <div class="card-body p-3">
                  <div class="row">
                    <div class="col-7 ">
                      <h4 class="text-primary"> {{connectors[i].type.startsWith('mennekes') ? ("type" |
                        translate)+'-2' : connectors[i].type | titlecase}}</h4>
                      <span
                        class="badge badge-pill bg-success mw-100">{{connectorsState[i]}}-{{getTranslatedText(allStates[connectorsState[i]]?.text)}}
                      </span>
                    </div>
                    <div class="col-5 d-flex justify-content-end align-items-center ">
                      <div class="d-flex justify-content-end align-items-center  ">
                        <label class="switch-sm mb-0  text-right">
                          <input type="checkbox" [(ngModel)]="permission[i]" disabled>
                          <span class="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CTM Device Info -->
        <div *ngIf="serial.includes('CTM')" class="m-2">
          <!-- Row 1: Estado y Sesión -->
          <div class="row g-3 mt-3">
            <div class="col-6">
              <div class="card h-100 shadow-sm">
                <div class="card-header text-center py-2">
                  <h6 class="mb-0 fw-bold">Estado Actual</h6>
                </div>
                <div class="card-body d-flex align-items-center justify-content-center">
                  <i class="fa-solid fa-play text-success fa-2x"></i>
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="card h-100 shadow-sm">
                <div class="card-header text-center">
                  <h6 class="mb-0 fw-bold">Sesión Actual</h6>
                </div>
                <div class="card-body d-flex flex-column justify-content-center p-1">
                  <div class="d-flex align-items-center justify-content-center mb-2">
                    <i class="fa-solid fa-user text-primary me-3"></i>
                    <span class="fw-medium text-dark">Jose Luis</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fa-solid fa-hourglass-half text-warning me-3"></i>
                    <span class="fw-bold text-dark">00:25:13</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Row 2: Consumos -->
          <div class="row g-3 mt-2">
            <div class="col-6">
              <div class="card h-100 shadow-sm">
                <div class="card-header text-center py-2">
                  <h6 class="mb-0 fw-bold">Consumo Sesión</h6>
                </div>
                <div class="card-body d-flex align-items-center justify-content-center">
                  <i class="fa-solid fa-bolt text-warning fa-2x me-3"></i>
                  <h4 class="mb-0 text-dark fw-bold">77 kWh</h4>
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="card h-100 shadow-sm">
                <div class="card-header text-center py-2">
                  <h6 class="mb-0 fw-bold">Consumo Total</h6>
                </div>
                <div class="card-body d-flex align-items-center justify-content-center">
                  <i class="fa-solid fa-chart-line text-success fa-2x me-3"></i>
                  <h4 class="mb-0 text-dark fw-bold">3,591 kWh</h4>
                </div>
              </div>
            </div>
          </div>

          <!-- Row 3: Precio -->
          <div class="row g-3 mt-2 mb-3">
            <div class="col-6">
              <div class="card h-100 shadow-sm">
                <div class="card-header text-center py-2">
                  <h6 class="mb-0 fw-bold">Precio Sesión</h6>
                </div>
                <div class="card-body d-flex align-items-center justify-content-center">
                  <i class="fa-solid fa-sack-dollar text-secondary fa-2x me-3"></i>
                                        <h4 class="mb-0 text-dark fw-bold">50 €</h4>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- ANC Device Info -->
        <div *ngIf="isRelaySchedulerSerial(serial)" class="m-2">

          <!-- Row 2: Salidas -->
          <div class="row g-3 mt-2">
            <div class="col-6">
              <div class="card h-100 shadow-sm">
                <div class="card-header text-center py-2">
                  <h6 class="mb-0 fw-bold">Salida 1</h6>
                </div>
                <div class="card-body d-flex align-items-center justify-content-center">
                      <i class="fa-solid fa-lightbulb text-warning-2 fa-2x me-3" *ngIf="channels.c1stat == 2 || channels.c1stat == 3"  ></i>
                      <i class="fa-solid fa-lightbulb text-grey fa-2x me-3" *ngIf="channels.c1stat == 0 || channels.c1stat == 1"  ></i>                    <h4 class="mb-0 text-dark fw-bold">ON</h4>
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="card h-100 shadow-sm">
                <div class="card-header text-center py-2">
                  <h6 class="mb-0 fw-bold">Salida 2</h6>
                </div>
                <div class="card-body d-flex align-items-center justify-content-center">
                      <i class="fa-solid fa-lightbulb text-warning-2 fa-2x me-3" *ngIf="channels.c2stat == 2 || channels.c2stat == 3"  ></i>
                      <i class="fa-solid fa-lightbulb text-grey fa-2x me-3" *ngIf="channels.c2stat == 0 || channels.c2stat == 1"  ></i>                    <h4 class="mb-0 text-dark fw-bold">OFF</h4>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- AST Device Info -->
        <div *ngIf="serial.includes('ANC2')" class="m-2">
          <!-- Row 1: Salida y Potencia -->
          <div class="row g-3 mt-3">
            <div class="col-6">
              <div class="card h-100 shadow-sm">
                <div class="card-header text-center py-2">
                  <h6 class="mb-0 fw-bold">Salida</h6>
                </div>
                <div class="card-body d-flex align-items-center justify-content-center">
                  <i class="fa-solid fa-lightbulb text-success fa-2x me-3"></i>
                  <h4 class="mb-0 text-dark fw-bold">ON</h4>
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="card h-100 shadow-sm">
                <div class="card-header text-center py-2">
                  <h6 class="mb-0 fw-bold">Potencia Activa</h6>
                </div>
                <div class="card-body d-flex align-items-center justify-content-center">
                  <i class="fa-solid fa-bolt text-warning fa-2x me-3"></i>
                  <h4 class="mb-0 text-dark fw-bold">850 W</h4>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- XEO Device Info -->
        <div *ngIf="serial.includes('XLUM')" class="m-2">
          <!-- Estado del Alumbrado -->
          <div class="row g-3 mt-1">
            <div class="col-12">
              <div class="card shadow-sm">
                <div class="card-header text-center py-2">
                  <h6 class="mb-0 fw-bold">Estado del Alumbrado</h6>
                </div>
                <div class="card-body d-flex align-items-center justify-content-center">
                  <i class="fa-solid fa-lightbulb text-success fa-2x me-3"></i>
                  <h4 class="mb-0 text-dark fw-bold">ACTIVO</h4>
                </div>
              </div>
            </div>
          </div>

          <!-- Potencias Trifásicas -->
          <div class="row g-3 mb-3">
            <div class="col-12">
              <div class="card shadow-sm">
                <div class="card-header text-center py-2">
                  <h6 class="mb-0 fw-bold">
                    Potencia
                  </h6>
                </div>
                <div class="card-body">
                  <!-- Potencia Total -->
                  <div class="row mb-3">
                    <div class="col-12 text-center">
                      <div class="d-flex align-items-center justify-content-center p-3 bg-light rounded">
                        <i class="fa-solid fa-bolt text-warning fa-2x me-3"></i>
                        <div>
                          <h5 class="mb-0 text-primary fw-bold">Total</h5>
                          <h3 class="mb-0 text-dark fw-bold">3,750 W</h3>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Potencias por Fases -->
                  <div class="row text-center">
                    <div class="col-4">
                      <div class="d-flex flex-column align-items-center p-2">
                        <!-- <i class="fa-solid fa-bolt text-danger fa-2x mb-2"></i> -->
                        <small class="text-muted fw-bold">Fase L1</small>
                        <h4 class="mb-0 text-dark fw-bold">1,250 W</h4>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="d-flex flex-column align-items-center p-2">
                        <!-- <i class="fa-solid fa-bolt text-warning fa-2x mb-2"></i> -->
                        <small class="text-muted fw-bold">Fase L2</small>
                        <h4 class="mb-0 text-dark fw-bold">1,180 W</h4>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="d-flex flex-column align-items-center p-2">
                        <!-- <i class="fa-solid fa-bolt text-success fa-2x mb-2"></i> -->
                        <small class="text-muted fw-bold">Fase L3</small>
                        <h4 class="mb-0 text-dark fw-bold">1,320 W</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="d-flex justify-content-center p-3">
        <button class="col-7 text-center btn btn-primary " (click)="goToDevice(locations[indice].title)">
          {{"moreInfo" | translate}}</button>
        <button class="col-1  btn btn-primary ms-2 p-1 " (click)="goToDiagnosis(locations[indice].title)"> <i
            class="fas fa-stethoscope text-white"></i> </button>
        <button class="col-1  btn btn-primary ms-1 p-1" (click)="goToSettings(locations[indice].title)"> <i
            class="fas fa-cog fa-fw"></i> </button>
      </div>
    </div>
  </div>


  <div class="map-container" [class.shrink]="info">
    <div id="map-container" style="min-height: calc(100vh - 168px);">
      <div id="map" style="min-height: calc(100vh - 168px);"></div>
    </div>
  </div>
</div>
